class WebShareButton extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.#handleClick();
      }
    });
  }

  #handleClick = () => {
    const { webShareTitle: title, webShareUrl: url, copiedLabel = '連結已複製' } = this.dataset;

    if (navigator.share) {
      navigator.share({ title, url });
    } else {
      navigator.clipboard.writeText(url)
        .then(() => this.#showTooltip(copiedLabel))
        .catch(() => this.#showTooltip(copiedLabel));
    }
  };

  #showTooltip(label) {
    document.querySelector('.ako-copy-tooltip')?.remove();

    const rect = this.getBoundingClientRect();

    const arrow = document.createElement('div');
    arrow.className = 'ako-copy-tooltip__arrow';

    const tooltip = document.createElement('div');
    tooltip.className = 'ako-copy-tooltip';
    tooltip.textContent = label;
    tooltip.style.left = `${rect.left + rect.width / 2}px`;
    tooltip.style.top = `${rect.top}px`;
    tooltip.appendChild(arrow);
    document.body.appendChild(tooltip);

    requestAnimationFrame(() => tooltip.classList.add('ako-copy-tooltip--visible'));

    setTimeout(() => {
      tooltip.classList.remove('ako-copy-tooltip--visible');
      setTimeout(() => tooltip.remove(), 150);
    }, 1800);
  }
}

customElements.define('web-share-button', WebShareButton);
